export enum DiseaseSpecializationTranslKey {
    ADD_NEW_DISEASE_SPECIALIZATION = "disease:specialization:addNewDiseaseSpecialization",
    DELETE_DISEASE_SPECIALIZATION = "disease:specialization:deleteDiseaseSpecialization",
    DELETE_DISEASE_SPECIALIZATION_PROMPT = "disease:specialization:deleteDiseaseSpecializationPrompt",
    DISEASE_SPECIALIZATION = "disease:specialization:diseaseSpecialization",
    DISEASE_SPECIALIZATION_ALREADY_EXISTS = "disease:specialization:diseaseSpecializationAlreadyExists",
    NO_SPECIALIZATIONS = "disease:specialization:noSpecializations",
}